import type { ScotsmanDimensionDefinition } from './scotsman.domain';

/** Stable SCOTSMAN dimension metadata (UI copy and tab labels). */
export const SCOTSMAN_DIMENSIONS: ScotsmanDimensionDefinition[] = [
  {
    dimension: 'Solution',
    letter: 'S',
    name: 'Solution fit',
    definition:
      "Does our offering solve the client's problem, and do we understand their business case?",
    checklistItems: [
      "Our solution maps to the client's stated problem & success metrics.",
      'We have proven Zühlke capabilities & relevant references in this domain.',
      'Client has expressed positive reaction to our approach.',
      'No major contractual / legal blockers (T&Cs, IP, data protection).',
    ],
  },
  {
    dimension: 'Competition',
    letter: 'C',
    name: 'Competition',
    definition: 'Who else is bidding, and how does our offering compare?',
    checklistItems: [
      'We have been proactively approached by client (Short / Longlisted).',
      'No clear client bias toward an incumbent or competitor.',
      'No competitor holds an overwhelming advantage (price, relationship, fit).',
      'No unresolved relationship issues from prior engagements.',
    ],
  },
  {
    dimension: 'Originality',
    letter: 'O',
    name: 'Originality',
    definition: 'What makes Zühlke unique or superior? Why are they talking to us?',
    checklistItems: [
      "Our unique benefits are reflected in the client's decision criteria.",
      'Client allows us to showcase our specific strengths (dialogue, pitch planned).',
      'We have a credible win theme tied to a strategic client priority.',
    ],
  },
  {
    dimension: 'Timescale',
    letter: 'T',
    name: 'Timescale',
    definition: 'Is there a specific timeframe, and can we realistically meet it?',
    checklistItems: [
      "Client's decision timeline aligns with our staffing window for bid & delivery.",
      "Client's scope and dependency plans are realistic (at first look!).",
      'Urgency: Decision / implementation is close enough to matter (not >6 months out).',
    ],
  },
  {
    dimension: 'Size',
    letter: 'S',
    name: 'Size',
    definition: 'Is the scale right for us, and is there potential for follow-on work?',
    checklistItems: [
      'Deal contributes meaningfully to Company / Industry target.',
      'Account potential (this + follow-on) justifies bid effort.',
      'Resource demand is within our capacity or can be scaled up in time.',
    ],
  },
  {
    dimension: 'Money',
    letter: 'M',
    name: 'Money',
    definition: 'Is the budget confirmed and aligned with our pricing?',
    checklistItems: [
      'Client has a confirmed and realistic budget.',
      'Our likely pricing fits within their budget range.',
      'They can demonstrate ability and willingness to pay.',
      'We can deliver profitably at the expected price point.',
    ],
  },
  {
    dimension: 'Authority',
    letter: 'A',
    name: 'Authority',
    definition: 'Are we talking to the decision-maker, or do we still need to reach them?',
    checklistItems: [
      'We have access to (or a clear path to) the economic decision-maker.',
      'We have an internal champion actively advocating for us.',
      'Decision-makers are aware a decision is being made & know the criteria.',
      'We are multi-threaded across 3+ stakeholders.',
    ],
  },
  {
    dimension: 'Need',
    letter: 'N',
    name: 'Need',
    definition: 'Does the client genuinely recognise the need, and is the business case solid?',
    checklistItems: [
      'Client has acknowledged a clear, urgent business need.',
      'Quantified business impact (cost of inaction / ROI) is established.',
      'Need maps to a strategic priority with executive sponsorship.',
      'Status quo is broken - change is required, not nice-to-have.',
    ],
  },
];

export const SCOTSMAN_DIMENSION_COUNT = SCOTSMAN_DIMENSIONS.length;
